module.exports = __webpack_public_path__ + "static/media/stories.53fcae5d.jpg";